var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCountryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7387 7.43771H4.8243C4.94626 5.98537 5.42845 4.59074 6.22112 3.37821C4.36926 3.88976 2.96696 5.48442 2.7387 7.43771ZM7.5007 3.51766C6.62785 4.65279 6.09143 6.01148 5.95384 7.43771H9.04755C8.90996 6.01148 8.37354 4.65279 7.5007 3.51766ZM9.04755 8.56271C8.90996 9.98894 8.37354 11.3476 7.5007 12.4828C6.62785 11.3476 6.09143 9.98894 5.95384 8.56271H9.04755ZM4.8243 8.56271H2.7387C2.96696 10.516 4.36926 12.1107 6.22112 12.6222C5.42845 11.4097 4.94626 10.015 4.8243 8.56271ZM8.78028 12.6222C9.57294 11.4097 10.0551 10.015 10.1771 8.56271H12.2627C12.0344 10.516 10.6321 12.1107 8.78028 12.6222ZM12.2627 7.43771H10.1771C10.0551 5.98537 9.57294 4.59074 8.78028 3.37821C10.6321 3.88976 12.0344 5.48442 12.2627 7.43771ZM1.58105 8.00021C1.58105 4.73088 4.23137 2.08057 7.5007 2.08057C10.77 2.08057 13.4203 4.73088 13.4203 8.00021C13.4203 11.2695 10.77 13.9199 7.5007 13.9199C4.23137 13.9199 1.58105 11.2695 1.58105 8.00021Z",
    fill: "#748399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/countryIcon.cbcd7439f835c6adb28adca69e61f69b.svg";
export { ForwardRef as ReactComponent };